import { render, staticRenderFns } from "./ConectEscRemoto.vue?vue&type=template&id=b0522b52&scoped=true"
import script from "./ConectEscRemoto.vue?vue&type=script&lang=js"
export * from "./ConectEscRemoto.vue?vue&type=script&lang=js"
import style0 from "./ConectEscRemoto.vue?vue&type=style&index=0&id=b0522b52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0522b52",
  null
  
)

export default component.exports